import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Single QueryClient instance shared across client render and SSR.
const queryClient = new QueryClient();

/**
 * App-wide context providers, with NO router inside.
 * The router (BrowserRouter on the client, StaticRouter on the server)
 * is supplied by the caller so the same tree can be hydrated or prerendered.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        {children}
      </TooltipProvider>
    </QueryClientProvider>
  );
}
